module.exports = __webpack_public_path__ + "static/media/iar_vehicle_police_selected.a950f5a8.svg";